import type { FC } from 'react';
import { useTheme } from 'styled-components';
import type { IIconsProps } from './types';
import { IconScale } from './types';

const Cash: FC<IIconsProps> = ({
  color,
  fillcolor,
  size = IconScale.M,
}: IIconsProps) => {
  const theme = useTheme();
  if (!color) {
    color = theme.palette.primary.main;
  }
  if (!fillcolor) {
    color = theme.palette.neutral['00'];
  }
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.7076 8.46117L6.39088 15.8334C6.76866 16.8714 7.91635 17.4066 8.95431 17.0288L21.097 12.6092C22.1349 12.2314 22.6701 11.0837 22.2923 10.0458L19.6091 2.67351C19.2313 1.63556 18.0836 1.10038 17.0456 1.47817L4.90294 5.89775C3.86499 6.27553 3.32981 7.42321 3.7076 8.46117Z"
        stroke={color}
        strokeWidth="2"
      />
      <path
        d="M8.17465 9.42427L7.99969 9.48795C7.77421 9.57002 7.65796 9.81933 7.74002 10.0448L8.46176 12.0278C8.54382 12.2532 8.79313 12.3695 9.01861 12.2874L9.19357 12.2237C9.77336 12.0127 10.4144 12.3116 10.6255 12.8914C10.6958 13.0847 10.9095 13.1843 11.1028 13.114L16.935 10.9913C17.1282 10.9209 17.2279 10.7072 17.1575 10.514C16.9465 9.93417 17.2455 9.29309 17.8252 9.08206L18.0002 9.01838C18.2257 8.93631 18.3419 8.687 18.2599 8.46153L17.5381 6.47858C17.4561 6.25311 17.2068 6.13685 16.9813 6.21892L16.8063 6.2826C16.2265 6.49363 15.5855 6.19469 15.3744 5.6149C15.3041 5.42164 15.0904 5.32199 14.8971 5.39233L9.06492 7.51508C8.87166 7.58542 8.77201 7.79912 8.84235 7.99238C9.05338 8.57217 8.75444 9.21325 8.17465 9.42427Z"
        stroke={color}
        strokeWidth="2"
      />
      <circle cx="12.9329" cy="8.93291" r="0.93291" fill={color} />
      <path
        d="M2 13V21C2 22.1046 2.89543 23 4 23H17C18.1046 23 19 22.1046 19 21V13C19 11.8954 18.1046 11 17 11H4C2.89543 11 2 11.8954 2 13Z"
        fill={fillcolor}
        stroke={color}
        strokeWidth="2"
      />
      <path
        d="M5.70833 15.5H5.45833C5.2052 15.5 5 15.7052 5 15.9583V18.0417C5 18.2948 5.2052 18.5 5.45833 18.5H5.70833C6.32965 18.5 6.83333 19.0037 6.83333 19.625C6.83333 19.8321 7.00123 20 7.20833 20H13.7917C13.9988 20 14.1667 19.8321 14.1667 19.625C14.1667 19.0037 14.6703 18.5 15.2917 18.5H15.5417C15.7948 18.5 16 18.2948 16 18.0417V15.9583C16 15.7052 15.7948 15.5 15.5417 15.5H15.2917C14.6703 15.5 14.1667 14.9963 14.1667 14.375C14.1667 14.1679 13.9988 14 13.7917 14H7.20833C7.00123 14 6.83333 14.1679 6.83333 14.375C6.83333 14.9963 6.32965 15.5 5.70833 15.5Z"
        stroke={color}
        strokeWidth="2"
      />
      <circle cx="10.3292" cy="16.8528" r="0.93291" fill={color} />
    </svg>
  );
};

export default Cash;
